import type { Resource } from '../../';
export const country_countries_UK: Resource = {"default":"United Kingdom"};
